import { Component, OnInit, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { SharedService } from '../../../services/shared.service';
import {
  AutoRefillAddSubView,
  AutoRefillMainTab,
  AUTO_REFILL_DEFAULT_PHARMACY_ID,
  AUTO_REFILL_PHARMACY_OPTIONS
} from './auto-refill.constants';
import {
  AutoRefillSelectedPatient,
  AutoRefillPatientProfileComponent
} from './auto-refill-patient-profile.component';
import { AutoRefillPatientSearchComponent } from './auto-refill-patient-search.component';
import { AutoRefillTodoTabComponent } from './auto-refill-todo-tab.component';
import { AutoRefillDialogService } from './auto-refill-dialog.service';
import { patientDisplayName, pickDto, resolveInitialPharmacyId } from './auto-refill.utils';

@Component({
  selector: 'app-misc-auto-refill',
  templateUrl: './auto-refill.component.html',
  styleUrls: ['./auto-refill.component.css']
})
export class MiscAutoRefillComponent implements OnInit {

  @ViewChild(AutoRefillTodoTabComponent, { static: false })
  private todoTab: AutoRefillTodoTabComponent;

  @ViewChild(AutoRefillPatientSearchComponent, { static: false })
  private patientSearch: AutoRefillPatientSearchComponent;

  @ViewChild(AutoRefillPatientProfileComponent, { static: false })
  private patientProfile: AutoRefillPatientProfileComponent;

  activeMainTab: AutoRefillMainTab = 'schedule_list';
  addSubView: AutoRefillAddSubView = 'search';
  selectedPharmacyId = AUTO_REFILL_DEFAULT_PHARMACY_ID;
  selectedPatient: AutoRefillSelectedPatient = null;

  constructor(
    public sharedService: SharedService,
    private autoRefillDialog: AutoRefillDialogService
  ) { }

  ngOnInit(): void {
    this.selectedPharmacyId = resolveInitialPharmacyId(
      AUTO_REFILL_DEFAULT_PHARMACY_ID,
      AUTO_REFILL_PHARMACY_OPTIONS
    );
  }

  selectMainTab(tab: AutoRefillMainTab): void {
    if (this.activeMainTab === tab) {
      return;
    }
    this.activeMainTab = tab;
    this.backToSearch();
    if (tab === 'schedule_list') {
      this.refreshTodoList();
      return;
    }
    this.loadPatientSearch();
  }

  onPharmacyIdChange(pharmacyId: number): void {
    this.selectedPharmacyId = pharmacyId;
    if (this.addSubView === 'profile') {
      this.backToSearch();
    }
  }

  onPatientSelected(row: any): void {
    this.selectedPatient = {
      patientId: parseInt(String(pickDto(row, 'id', 'Id')), 10),
      patientName: patientDisplayName(row),
      facilityId: parseInt(String(pickDto(row, 'facilityId', 'FacilityId') || '0'), 10),
      facilityName: String(pickDto(row, 'facilityName', 'FacilityName') || '').trim()
    };
    this.addSubView = 'profile';
  }

  backToSearch(): void {
    this.addSubView = 'search';
    this.selectedPatient = null;
  }

  onCheckRow(row: any): void {
    var self = this;
    this.autoRefillDialog.openConfirm(row, function () {
      self.onModalCompleted();
    });
  }

  onHistoryRow(row: any): void {
    this.autoRefillDialog.openHistory(row);
  }

  onDeactivateRow(row: any): void {
    var self = this;
    this.autoRefillDialog.openDeactivate(row, function () {
      self.onModalCompleted();
    });
  }

  onEditRow(row: any): void {
    var self = this;
    this.autoRefillDialog.openEditSchedule(row, function () {
      self.onModalCompleted();
    });
  }

  onModalCompleted(): void {
    if (this.activeMainTab === 'schedule_list') {
      this.refreshTodoList();
    }
    if (this.addSubView === 'profile' && this.patientProfile) {
      this.patientProfile.loadSchedules();
    }
  }

  onScheduleSaved(): void {
    Swal.fire({
      icon: 'success',
      title: 'Saved',
      text: 'Schedule saved successfully.',
      confirmButtonText: 'OK'
    });
  }

  onChildError(message: string): void {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: message,
      confirmButtonText: 'OK'
    });
  }

  private refreshTodoList(): void {
    if (this.todoTab) {
      this.todoTab.loadTodoList();
    }
  }

  private loadPatientSearch(): void {
    var self = this;
    setTimeout(function () {
      if (!self.patientSearch) {
        return;
      }
      if (self.patientSearch.totalCount === 0 && !self.patientSearch.patientsLoading) {
        self.patientSearch.load();
      }
    }, 0);
  }
}
